import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {Question} from '../../models/underwriter.model';
import {newGuid} from '../question-helper';
import {NgxCurrencyConfig, NgxCurrencyInputMode} from 'ngx-currency';
import { GlobalQuestionService } from '../../services/global-question.service';
import { QuestionFlowSessionQuery } from '../state/question-flow-session.query';
//import { AddonModalComponent } from 'src/app/modules/quotes/quote-customize-cover-add-ons/addon-modal/addon-modal.component';
import { VapService } from '../../services/vap.service';
import { VapParentQuestion } from '../../models/vap-parent-question';
import { scrollToItem, getDescription } from '../../utilities';

declare const $: any;
declare function initReadMore(): any;

@Component({
    selector: 'app-question-super-vaps-control',
    templateUrl: './question-super-vaps-control.component.html',
    styleUrls: ['./question-super-vaps-control.component.scss'],
    standalone: false
})
export class QuestionSuperVapsControlComponent implements OnInit, AfterViewInit {

  @Input() question: Question;
  @Input() readOnly = false;
  @Input() showLabel = true;
  @Input() showLabelQuestionCopy = false;
  @Output() questionAnswer = new EventEmitter();
  @Output() enableButtonFromChild = new EventEmitter<boolean>();

  uniqueControlName = `textbox-currency-${newGuid()}`;
  uniqueId = `textbox-currency-id-${newGuid()}`;
  value = 0;
  maskOptions: NgxCurrencyConfig;
  session_details: any;
  dataset: any;
  benefits: any;
  selectedBenefit: any;
  questions: any = [];
  currentQuestion: any;
  showCopy = false;
  continueDisabled = false;
  getDescription = getDescription;
  constructor(
    public questionService: GlobalQuestionService,
    public vapService: VapService,
    private questionFlowSessionQuery: QuestionFlowSessionQuery,
  ) { 

  }

  ngOnInit(): void {
    if (this.question?.answer) {
      this.value = +this.question.answer;
    }
  }

  ngAfterViewInit(): void {
    this.maskOptions = {
      max: this.question?.max_val ? this.question?.max_val : null,
      min: null,
      allowZero: true,
      nullable: false,
      inputMode: NgxCurrencyInputMode.Financial,
      align: 'left',
      allowNegative: false,
      prefix: 'R ',
      decimal: '.',
      suffix: '',
      thousands: ' ',
      precision: 0
    };
    this.getSuperVapsControl();
  }
  getSuperVapsControl(): void {
    this.questionService.spinner(true);
    this.session_details = this.questionFlowSessionQuery.getValue();
    const parameters = new Map<string, string>();
    parameters.set('session_id', this.session_details?.session_id);
    parameters.set('flow_id', this.question?.flow_id.toString());
    parameters.set('class_id', this.question?.product_class_id.toString());
    parameters.set('item_id', this.question?.item_id.toString());
    parameters.set('question_id', this.question?.cent_aq_question_id.toString());
    parameters.set('vaps_id', this.selectedBenefit?.vaps_id.toString());
    parameters.set('location_id', this.question?.location_id.toString());
    this.questionService.runCommandNew('getSuperVapsControl', parameters).subscribe(dataset => {
        this.questionService.spinner(false);
        this.dataset = dataset;
        const subHeaderText = this.dataset.find(x => x.entry_type === 'label')?.label_text;
        $("#sub-header").html(subHeaderText).toggleClass('d-none', !subHeaderText);
        this.dataset.forEach(x => { if (x.entry_type === 'benefit') 
          { 
            try{
              x.itk = JSON.parse(x.itk); 
              x.itk = x.itk.sort((a, b) => a.display_order - b.display_order);
              x.wording = JSON.parse(x.wording); 
              x.questions = JSON.parse(x.questions); 
            }
            catch(e){ }
          } });
          this.benefits = this.dataset.filter(x => x.entry_type === 'benefit');
         this.showCopy = this.benefits[0].copy == 1;
          setTimeout(() => {
            this.initSliders();
            initReadMore();         
          }, 100);
          this.question.answer = "Super Vaps Control";
          this.questionAnswer.emit(this.question);
         
          
    },error => {
      this.questionService.spinner(false);
      $('#error-modal').modal('show');
    });
  }
  initSliders(): void {
    $(".slider--traffic").each(function () {
      var $slider = $(this)
      $slider.slick({
        dots: true,
        arrows: true,
        fade: true,
        speed: 400,
        cssEase: "ease-in",
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        swipeToSlide: true,
        prevArrow: '<button type="button" class="slick-prev"><svg class="icon"><use xlink:href="#right-small"></use></svg></button>',
        nextArrow: '<button type="button" class="slick-next"><svg class="icon"><use xlink:href="#right-small"></use></svg></button>',
        rows: 0,
      })
    })
  }
  removeBenefit(benefit: any): void {
    this.questionService.spinner(true);
    this.selectedBenefit = null;
    const parameters = new Map<string, string>();
    parameters.set('session_id', this.session_details?.session_id);
    parameters.set('class_id', benefit?.class_id.toString());
    parameters.set('item_id', (benefit?.item_id ?? benefit?.location_id)?.toString());
    parameters.set('vaps_id', benefit?.vaps_id.toString());
    this.questionService.runCommandNew('removeBenefit', parameters).subscribe(result => {
        this.questionService.spinner(false);
        this.getSuperVapsControl();
    },error => {
      this.questionService.spinner(false);
      $('#error-modal').modal('show');
    });
    // this.benefits = this.benefits.filter(x => x.id!== benefit.id);
    // this.question.answer = this.benefits.map(x => x.id).join(',');
    // this.questionAnswer.emit(this.question);
  }
  openAddOnModel(vap: any): void {
    
      // this.vap =  vap;
      // console.log(this.vap)
      // if (this.vap) {
      //   this.vapService.getVapQuestion(this.vap?.class_id, this.vap?.vaps_id)
      //     .subscribe({
      //       next: (questions: VapParentQuestion[]) => {
      //         if (questions?.length) {
      //           this.addonModalComponent.showModal(this.vap, questions[0], this.question?.product_id);
      //         }
      //       }
      //     });
      // }
      
  
  }
  openQuestions(benefit: any, id: string): void {
    this.selectedBenefit = benefit;
    //this.selectedBenefit.add = 0;
    this.selectedBenefit.cancel = 1;
    this.selectedBenefit.edit = 0;
    this.currentQuestion = this.selectedBenefit.questions.find(x => x.flow_index === 1);
    $(`#demo-complex-add-container-${id}`).removeClass('d-none');
    $(`#demo-complex-add-btn-${id}`).addClass('d-none');
    $(`#demo-simple-carousel-${id}`).addClass('d-none');
    setTimeout(() => {
      scrollToItem(`demo-complex-add-container-${id}`);
      //$('#demo-complex-add-container').scrollIntoView({ behavior: "smooth", block: "start" })
    }, 100);
    
  }
  cancelBenefit(benefit: any, id: string): void{
    this.selectedBenefit = benefit;
    this.selectedBenefit.add = 1;
    this.selectedBenefit.cancel = 0;
    $(`#demo-complex-add-container-${id}`).addClass('d-none');
    $(`#demo-simple-carousel-${id}`).removeClass('d-none');
    $(`#demo-complex-add-btn-${id}`).removeClass('d-none');
    console.log(benefit)
    this.removeBenefit(benefit);
  }
  questionAnswerResponse(event: any): void {
    console.log(event);
    //return;
    this.questionService.saveAnswer(this.session_details.session_id, event.cent_aq_question_id, event.product_class_id, event.item_id,event.answer,event.answer_id,'',event.flow_id,'',event.vaps_id,event.location_id).subscribe(result => {
      this.questionService.spinner(false);
      //this.nextQuestion();
    },error => {
      this.questionService.spinner(false);
      $('#error-modal').modal('show');
    });
  }
  nextQuestion(): void {
    this.continueDisabled = false;
    this.currentQuestion = this.selectedBenefit.questions.find(x => x.cent_aq_question_id === this.currentQuestion.next);
    if (!this.currentQuestion){
      this.getSuperVapsControl();
    }
  }
  previousQuestion(): void {
    this.currentQuestion = this.selectedBenefit.questions.find(x => x.next === this.currentQuestion.cent_aq_question_id);
  }
  benefitAdded(event: any): void {

  }
  showWording(benefit: any): void {
    this.selectedBenefit = benefit;
  }
}

